__turbopack_context__.v({
  "grid": "object-info-table-module-scss-module__M2GyKa__grid",
  "label": "object-info-table-module-scss-module__M2GyKa__label",
});
